import React from 'react';
import { motion } from 'framer-motion';

const physicalWellbeingData = [
    {
        id: 1,
        title: "Medical Coverage",
        description: "At Mobikode, we care about your well-being beyond the workplace. Our medical coverage helps you and your family access the care you need, giving you confidence, support, and peace of mind every day.",
        image: "/assets/benefits/item4.png"
    },
    {
        id: 2,
        title: "Coverage of assistive devices",
        description: "At Mobikode, we care about your everyday well-being. Our assistive device coverage helps you access the support you need, making daily life easier, more comfortable, and empowering you to thrive both personally and professionally.",
        image: "/assets/benefits/item5.png"
    },
    {
        id: 3,
        title: "Policies catering to our people with disabilities ",
        description: "At Mobikode, we believe everyone deserves the support they need to do their best work. Our inclusive policies and accessibility-focused accommodations help team members with disabilities feel valued, comfortable, empowered, and supported every day.",
        image: "/assets/benefits/item6.png"
    }
];

const PhysicalWellbeingSection = () => {
    const fadeUpVariant = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.2 }
        }
    };

    return (
        <section className="w-full pb-[40px] md:pb-[100px] bg-white font-sora">
            <div className="max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px]">
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    variants={fadeUpVariant}
                    className="mb-[32px] md:mb-[60px] max-w-[800px]"
                >
                    <h2 className="text-[20px] md:text-[30px] font-[600] text-[#01386A] tracking-tight mb-[12px] md:mb-[16px]">
                        Your physical well-being
                    </h2>
                    <p className="text-[#49577A] text-[14px] md:text-[16px] font-graphik font-[500] leading-[1.6]">
                        At Mobikode, we care about you beyond work. Enjoy benefits and support that help you stay healthy, secure, and focused on what matters most, yourself and your family.
                    </p>
                </motion.div>

                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-[16px] md:gap-[24px]"
                >
                    {physicalWellbeingData.map((card) => (
                        <motion.div
                            key={card.id}
                            variants={fadeUpVariant}
                            className="group relative w-full h-[300px] sm:h-[350px] md:h-[400px] overflow-hidden cursor-pointer bg-[#01386A]"
                        >
                            <img
                                src={card.image}
                                alt={card.title}
                                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-105"
                            />

                            <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/50 to-transparent"></div>

                            <div className="absolute bottom-0 left-0 p-[20px] sm:p-[24px] md:p-[32px] w-full flex flex-col justify-end">
                                <h3 className="text-white text-[16px] md:text-[20px] font-[600] font-sora leading-[1.3] transition-transform duration-500 ease-in-out transform md:group-hover:-translate-y-2">
                                    {card.title}
                                </h3>

                                <div className="grid grid-rows-[1fr] md:grid-rows-[0fr] transition-[grid-template-rows] duration-500 ease-in-out group-hover:md:grid-rows-[1fr]">
                                    <div className="overflow-hidden">
                                        <p className="text-white/90 text-[14px] md:text-[16px] font-graphik font-[500] leading-[1.5] md:leading-[1.6] pt-[8px] md:pt-[12px] opacity-100 md:opacity-0 transition-opacity duration-500 delay-100 group-hover:md:opacity-100">
                                            {card.description}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>

            </div>
        </section>
    );
};

export default PhysicalWellbeingSection;